import { CommonWidgetConfig } from '../../models';
import { WidgetDetails } from '../models';
import EditForm from './EditForm';
import Widget from './Widget';

export const details: WidgetDetails = {
  type: "chat",
  name: "Chat History"
}

export type Config = CommonWidgetConfig  & {
  type: "chat";
};


export { EditForm, Widget };
